import { COGNITO_DOMAIN, COGNITO_CLIENT_ID } from "../authConfig";

export async function cognitoRefresh() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) throw new Error("No hay refreshToken (requiere login).");

  const params = new URLSearchParams({
    grant_type: "refresh_token",
    client_id: COGNITO_CLIENT_ID,
    refresh_token: refreshToken,
  });

  const res = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: params,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error_description || "Error refrescando token");

  // Cognito normalmente regresa access_token (y a veces id_token), NO regresa refresh_token de nuevo
  if (data.access_token) localStorage.setItem("accessToken", data.access_token);
  if (data.id_token) localStorage.setItem("idToken", data.id_token);

  localStorage.setItem("tokenSavedAt", String(Date.now()));

  return data;
}
